import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Tooltip from 'components/application/Tooltip';

export default function DisableableOptionChoice({
  disabled,
  disabledTooltipText = '',
  label,
  warning,
}) {
  return (
    <span className='tooltip-parent'>
      {disabled && (
        <Tooltip
          className='tooltip-dark--max-w-xxs'
          placement='left'
          tooltip={disabledTooltipText}
          trigger='hover'
        />
      )}
      <a
        className={classNames(
          'tw-text-m tw-font-medium tw-tracking-auto',
          warning ?
            'tw-text-red-600 hover:tw-text-red-600'
          : 'tw-text-grey-700 hover:tw-text-grey-700',
        )}
        href='#0'
      >
        {label}
      </a>
    </span>
  );
}

DisableableOptionChoice.propTypes = {
  label: PropTypes.string.isRequired,
  warning: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  disabledTooltipText: PropTypes.string,
};
